import { useLocation, useNavigate } from "react-router-dom";

import "../css/AppointmentConfirmation.css";
import checkIcon from "../assets/images/check_circle.png";
import DoctorAssignedCard from "../components/SessionDetail/DoctorAssignedCard";
import WhatHappensNext from "../components/WhatHappensNext";

const HoldBookingConfirmation = ({
  bookingData: bookingDataProp = null,
  holdData: holdDataProp = null,
  alreadyConfirmed = false,
}) => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const booking = bookingDataProp || state?.booking;
  const hold = holdDataProp || state?.hold;

  if (!booking || !hold) {
    return <p style={{ padding: 24 }}>Booking details not available.</p>;
  }

  const appointmentDate = new Date(booking.start_at).toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
  const appointmentTime = new Date(booking.start_at).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return (
    <div
      className="container"
      style={{
        backgroundImage: `url(${require("../assets/images/BackgroundBig.png")})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="header-container">
        <img src={checkIcon} alt="Confirmed" className="tick-icon" />
        <span className="header-text">Appointment Confirmed!</span>
      </div>

      <div className="content-container">
        <h3 className="session-title">Physiotherapy Session with Dr. {booking.therapist_name}</h3>

        <div className="details-row">
          <div className="detail-column">
            <span className="detail-label">Name</span>
            <span className="detail-value">{booking.user_name}</span>
          </div>
          <div className="detail-column-right">
            <span className="detail-label">Mobile</span>
            <span className="detail-value">{booking.user_phone}</span>
          </div>
        </div>

        <div className="details-row">
          <div className="detail-column">
            <span className="detail-label">Pain Condition</span>
            <span className="detail-value">{hold.pain_condition || "N/A"}</span>
          </div>
          <div className="detail-column-right">
            <span className="detail-label">Fees</span>
            <span className="detail-value">Rs {booking.current_payment}</span>
          </div>
        </div>

        <div className="w-full mt-8 mb-8 mr-20">
          <DoctorAssignedCard doctorName={booking.therapist_name} className="w-full" />
        </div>

        <div className="section">
          <div className="section-row">
            <img src={require("../assets/images/calendar.png")} alt="calendar" className="section-icon" />
            <div>
              <div className="section-label">Date & Time</div>
              <div className="section-value">{appointmentDate} | {appointmentTime}</div>
            </div>
          </div>
        </div>

        <div className="section">
          <div className="section-row">
            <img src={require("../assets/images/location.png")} alt="location" className="section-icon" />
            <div>
              <div className="section-label">Complete Address</div>
              <div className="section-value">{booking.user_address}</div>
            </div>
          </div>
        </div>

        <div className="message-container">
          <p className="message-text">
            {alreadyConfirmed
              ? "This booking had already been confirmed earlier. We are showing the confirmed session details again for your reference."
              : "Your session has been confirmed successfully. Our team will share any further updates on WhatsApp."}
          </p>
        </div>

        <div className="appointment-id-container">
          <span className="appointment-id-label">Appointment ID</span>
          <span className="appointment-id-value">{booking.booking_id}</span>
        </div>

        <WhatHappensNext />

        <button className="back-button" onClick={() => navigate("/")}>
          Back To Home
        </button>
      </div>
    </div>
  );
};

export default HoldBookingConfirmation;
